import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Box, CircularProgress } from '@mui/material';
import { syncAllData } from '../services/syncService';
import backgroundImage from '../assets/image.jpg';
import { TENANT_LOGO_URL } from '../config/tenant';
import {URL} from "../config/constants";

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoggingIn, setIsLoggingIn] = useState(false); // <-- флаг загрузки
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoggingIn(true);

        try {
            const data = await fetch(URL + '/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password })
            }).then(response => response.json());

            if (!data.token) {
                alert('Login failed');
                return;
            }

            localStorage.setItem('token', data.token);
            localStorage.setItem('refreshToken', data.refresh_token);

            const userData = await fetch(URL + '/user', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${data.token}`,
                    'Content-Type': 'application/json'
                }
            }).then(response => response.json());

            localStorage.setItem('firstName', userData.firstName || '');
            localStorage.setItem('userId', userData.userId || '');
            if (userData.employeeId) {
                localStorage.setItem('employeeId', userData.employeeId);
            } else {
                localStorage.setItem('employeeId', '');
            }
            localStorage.setItem('lastName', userData.lastName || '');
            localStorage.setItem('employeeFullName', userData.employeeFullName || '');
            localStorage.setItem('employeeDivision', userData.employeeDivision || '');
            localStorage.setItem('employeeCompanyCode', userData.employeeCompanyCode || '');
            localStorage.setItem('employeePhone', userData.employeePhone || '');
            localStorage.setItem('employeeMVR', userData.employeeMVR || '');
            localStorage.setItem('roles', JSON.stringify(userData.roles || []));

            // Сразу в приложение: данные докачиваются в фоне, ход виден в
            // уведомлении синка (SyncProgressNotification) — так же, как синк
            // после обновления приложения. Ждать всю загрузку на экране входа
            // юзер не хочет (10/15). Синк — после перехода, когда уведомление
            // уже смонтировано (оно появляется только у вошедшего).
            navigate('/main');
            setTimeout(() => {
                syncAllData().catch(err => console.error('[Login] Background sync failed:', err));
            }, 300);
        } catch (err) {
            console.error('Error logging in:', err);
        } finally {
            setIsLoggingIn(false);
        }
    };

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100vw',
                height: '100vh',
                overflow: 'hidden',
            }}
        >
            <Box
                component="img"
                src={backgroundImage}
                alt="Background"
                sx={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0,
                    objectFit: 'cover',
                    zIndex: -1,
                }}
            />
            <Box
                sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    padding: '20px',
                }}
            >
                <Box
                    sx={{
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        padding: '40px',
                        borderRadius: '12px',
                        boxShadow: '0px 8px 30px rgba(0, 0, 0, 0.2)',
                        maxWidth: '400px',
                        width: '100%',
                        margin: '0 auto',
                    }}
                >
                    <>
                        <img
                            src={TENANT_LOGO_URL}
                            alt="Logo"
                            style={{
                                maxHeight: '140px',
                                margin: "10px auto",
                                display: "block"
                            }}
                        />
                    </>
                    <form onSubmit={handleLogin}>
                        <TextField
                            label="Email"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            sx={{ backgroundColor: 'white' }}
                        />
                        <TextField
                            label="Password"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            sx={{ backgroundColor: 'white' }}
                        />

                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{
                                marginTop: '30px',
                                padding: '12px',
                                fontSize: '1rem',
                            }}
                            // Блокируем кнопку, если идет запрос
                            disabled={isLoggingIn}
                            // Иконка - спиннер во время загрузки
                            startIcon={
                                isLoggingIn ? (
                                    <CircularProgress color="inherit" size={20} />
                                ) : null
                            }
                        >
                            {isLoggingIn ? 'Logging in...' : 'Login'}
                        </Button>

                    </form>
                </Box>
            </Box>
        </Box>
    );
};

export default LoginPage;
